import axios from 'axios'
import store from '@/store'
import { baseurl } from '@/libs/config'

import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)

import { Toast } from 'cube-ui'

Vue.use(Toast)

const baseURL = baseurl
const Axios = axios.create({
baseURL: baseURL,
withCredentials: true,
headers:{
"content-Type": "application/json"
},
timeout: 1000 * 300
})

const toast = Toast.$create({
time: 0,
txt: '加载中'
})
Axios.interceptors.request.use(config => {
if(config.data && !!config.data.keyword){
config.data.keyword = config.data.keyword.trim();
}
toast.show()
return config;
}, error => {
console.log(error);
return Promise.reject(error);
});

Axios.interceptors.response.use(res => {
const apiRes = res.data;
if(res && (res.data.code == 10011)){
store.dispatch("noTokenLogOut")
return;
}
if(res && res.data.code !== 10000){
var msg = res && res.data && res.data.message ? res.data.message : '请求失败，请检查网络';
Vue.$vux.toast.text(msg, 'middle');
}
toast.hide();
return apiRes;
}, async error => {
console.dir(error);
toast.hide();
return Promise.reject(error);
});


export default Axios



// WEBPACK FOOTER //
// ./src/libs/http/index.js